import React from 'react';
import { Box, Card, Text } from '@front/gatsby-ui';
import OrderAssignment from '@front/blocks/src/order-assignment';

const OrderFormWide = () => (
  <Box
    width="100%"
    bg="basic.0"
    py={{ _: 3, md: 4 }}
    px={{ _: 3, md: '40px' }}
    display={{
      _: 'flex',
      md: 'block',
    }}
    sx={{
      boxShadow: 'large',
      flexDirection: 'column',
      alignItems: 'center',

      '.bb-orderFormAssignment': {
        mx: 'auto',
      },
    }}
  >
    <Text
      variant="subtitle1"
      m={0}
      mb={3}
      color="basic.5"
      textAlign={{ _: 'center', md: 'left' }}
    >
      Hire an expert now
    </Text>
    <OrderAssignment
      horizontalLayout
      mobileFlowBreakpoint={768}
      termsLink="/terms-and-conditions/"
      policyLink="/privacy-policy/"
      forgotPasswordLink="auth_password_reset"
      submitText="Find expert"
    />
  </Box>
);

export const VerticalOrder = () => (
  <Card
    maxWidth="380px"
    p={3}
    bg="basic.0"
    sx={{
      position: 'relative',
    }}
  >
    <Text
      variant="subtitle1"
      m={0}
      mb={3}
      color="basic.5"
    >
      Hire an expert now
    </Text>
    <OrderAssignment
      horizontalLayout={false}
      termsLink="/terms-and-conditions/"
      policyLink="/privacy-policy/"
      forgotPasswordLink="auth_password_reset"
      submitText="Find your expert"
      showGdprByDefault
    />
  </Card>
);

export default OrderFormWide;
